/* BVP 2026-10-28 (lot B1) — corrections JS globales (en-tête, tiroir panier, sélecteur de langue).
   Idempotent : se relance sur InstantClick 'change'. Aucune dépendance. */
(function () {
  'use strict';

  /* ---------- Tiroir panier (appli Vanga, dans un shadow DOM) : habillage noir et or ----------
     Le contenu du tiroir est dans un shadow root ouvert : une feuille de la page ne peut pas l'atteindre.
     On y glisse une <style> (noms de classes vanga-cart__* stables). Le texte du code de réduction
     automatique est remplacé par un libellé neutre (variable CSS --bvp-disc-label posée par header.liquid). */
  var VANGA_CSS = [
    '.font-sans{font-family:"Manrope","Inter",system-ui,sans-serif!important}',
    '.fixed.inset-0.md\\:bg-black\\/60{background:rgba(5,5,8,.78)!important;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}',
    '.min-h-full.bg-white{background:linear-gradient(180deg,#14121a 0%,#0c0b10 100%)!important;color:#fff!important;border:1px solid rgba(216,169,52,.28);border-radius:18px;box-shadow:0 30px 80px -30px rgba(0,0,0,.9)}',
    '@media (max-width:767px){.min-h-full.bg-white{border-radius:0;border-left:0;border-right:0}}',
    '.ctitle{font-family:"Saira Condensed","Manrope",sans-serif!important;font-weight:800!important;text-transform:uppercase;letter-spacing:1.5px;color:#fff;font-size:2rem;line-height:1.1}',
    '.vanga-cart__close{color:#d8a934!important;width:44px;height:44px;display:inline-flex;align-items:center;justify-content:center}',
    '.vanga-cart__close:hover{color:#f6d77c!important}',
    '.vanga-cart__close svg{width:26px;height:26px}',
    '[class*="divide-y"]>*{border-color:rgba(255,255,255,.1)!important}',
    '.vanga-cart__item img,.vanga-cart__item .rounded-full{border-radius:12px!important;object-fit:contain!important;background:#fff;padding:2px}',
    '.vanga-cart__item-title,.vanga-cart__item-title a,.vanga-cart__item-link{color:#fff!important}',
    '.vanga-cart__item-title a:hover,.vanga-cart__item-link:hover{color:#f6d77c!important}',
    '.vanga-cart__item-variant,.text-neutral-500,.text-neutral-400{color:rgba(255,255,255,.66)!important}',
    '.vanga-cart__item-price dd,.vanga-cart__item-price{color:#fff}',
    '.text-gray-500,.line-through{color:rgba(255,255,255,.55)!important}',
    '.vanga-cart__item-quantity>div,.rounded-md.border.border-neutral-300,.rounded-md.border-neutral-300{background:rgba(255,255,255,.05)!important;border:1px solid rgba(216,169,52,.35)!important;border-radius:10px!important}',
    '.vanga-cart__item-quantity button,.shadow-sm button{color:#d8a934!important;font-size:1.1rem}',
    '.vanga-cart__item input[type=number]{color:#fff!important;background:transparent!important}',
    '.text-brand-accent{color:#d8a934!important}',
    '.bg-brand-accent{background:linear-gradient(90deg,#b88d1c,#f6d77c)!important}',
    '.vanga-cart__promotion{background:#17151d!important;border:1px solid rgba(216,169,52,.22)!important;color:#fff;border-radius:14px!important}',
    '.vanga-cart__promotion .bg-neutral-300,.vanga-cart__promotion-progress{background:rgba(255,255,255,.12)!important}',
    '.vanga-cart__promotion svg{color:#d8a934}',
    '.vanga-cart__offer-item-price{color:#f6d77c!important}',
    '.vanga-cart__offer-item img{background:#fff;border-radius:10px!important;padding:2px}',
    '.vanga-cart__offer-add{background:linear-gradient(135deg,#d8a934,#b88d1c)!important;color:#0c0b10!important;font-family:"Saira Condensed","Manrope",sans-serif!important;font-weight:800!important;letter-spacing:1px;text-transform:uppercase;min-height:40px;border-radius:10px!important}',
    '.vanga-cart__offer-add:hover{filter:brightness(1.08);opacity:1!important}',
    '.vanga-cart__summary,.vanga-cart__summary dt,.vanga-cart__summary dd{color:#fff}',
    '.vanga-cart__summary-discount dd{color:#f6d77c}',
    '.vanga-cart__summary-discount .bg-neutral-100{background:rgba(216,169,52,.16)!important;border:1px solid rgba(216,169,52,.35);border-radius:999px!important;max-width:none!important;padding:2px 10px!important}',
    '.vanga-cart__summary-discount .bg-neutral-100 .truncate{font-size:0!important;color:#f6d77c!important;max-width:none!important}',
    '.vanga-cart__summary-discount .bg-neutral-100 .truncate::after{content:var(--bvp-disc-label,"");font-size:12px;font-weight:700;color:#f6d77c}',
    '.vanga-cart__summary-discount .bg-neutral-100 svg{color:#d8a934;stroke:#d8a934}',
    '.vanga-cart__proceed-custom{background:linear-gradient(135deg,#f0cd6e 0%,#d8a934 45%,#b88d1c 100%)!important;color:#0c0b10!important;min-height:56px;border-radius:12px!important;font-family:"Saira Condensed","Manrope",sans-serif!important;font-weight:800!important;font-size:1.1rem!important;letter-spacing:1.6px;text-transform:uppercase;box-shadow:0 14px 30px -16px rgba(216,169,52,.7)}',
    '.vanga-cart__proceed-custom:hover{filter:brightness(1.06);opacity:1!important}',
    '.vanga-cart__proceed-custom span{color:#0c0b10!important}',
    '.vanga-cart__proceed-custom{white-space:nowrap;padding-left:14px!important;padding-right:14px!important}',
    '.vanga-cart__proceed .w-auto,.vanga-cart__proceed>.w-auto{width:100%!important}',
    '@media (min-width:1024px){.vanga-cart__proceed-wrap-custom>.flex-1{display:none}.vanga-cart__proceed-wrap-custom>div{flex:0 0 auto!important;width:100%;max-width:340px;margin-left:auto}}',
    '.vanga-cart__proceed-wrap-custom>div:not(.flex-1){width:100%}',
    '[class*="rounded-t-xl"]{background:#100f15!important;border-top:1px solid rgba(216,169,52,.35);box-shadow:0 -12px 30px -14px rgba(0,0,0,.8)!important}',
    '.vanga-cart__empty-button{background:linear-gradient(135deg,#f0cd6e 0%,#d8a934 45%,#b88d1c 100%)!important;color:#0c0b10!important;min-height:52px;border-radius:12px!important;font-family:"Saira Condensed","Manrope",sans-serif!important;font-weight:800!important;font-size:1.05rem!important;letter-spacing:1.4px;text-transform:uppercase}',
    '.min-h-full h2{font-family:"Saira Condensed","Manrope",sans-serif!important;font-weight:800!important;text-transform:uppercase;letter-spacing:1.5px}',
    '.bvp-empty{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin:22px 16px 0;max-width:560px}',
    '.bvp-empty a{display:inline-flex;align-items:center;min-height:44px;padding:0 16px;border:1px solid rgba(216,169,52,.4);border-radius:999px;color:#fff;font-weight:700;font-size:13px;text-decoration:none;background:rgba(255,255,255,.04)}',
    '.bvp-empty a:hover{border-color:#d8a934;color:#f6d77c}',
    '.hover\\:underline:hover{text-decoration:underline}',
    'button:focus-visible,a:focus-visible,input:focus-visible{outline:2px solid #d8a934!important;outline-offset:2px}'
  ].join('\n');

  /* Passe 3 : le cadeau du jeu (une seule pièce, 0 €) n'a pas de sélecteur de quantité dans le tiroir ; « Supprimer » reste. */
  var GV = String((window.__bvpgCfg && window.__bvpgCfg.v) || 53154030682399).replace(/\D/g, '') || '53154030682399';
  var GIFT = '.vanga-cart__item:has(a[href*="variant=' + GV + '"])';
  VANGA_CSS += '\n' + GIFT + ' .vanga-cart__item-quantity,' + GIFT + ' [class*="leading-8"]{display:none!important}';

  function vanga() {
    var host = document.getElementById('vanga-smartcart');
    var sr = host && host.shadowRoot;
    if (!sr || sr.getElementById('bvp-vanga')) return !!(sr && sr.getElementById('bvp-vanga'));
    var st = document.createElement('style');
    st.id = 'bvp-vanga';
    st.textContent = VANGA_CSS;
    sr.appendChild(st);
    return true;
  }
  /* Panier vide : au lieu d'une page vide avec un seul bouton, on propose les accès rapides du menu (déjà traduits dans la page). */
  function vangaEmpty() {
    var host = document.getElementById('vanga-smartcart'), sr = host && host.shadowRoot;
    if (!sr) return false;
    var btn = sr.querySelector('.vanga-cart__empty-button');
    if (!btn) return false;
    if (sr.querySelector('.bvp-empty')) return true;
    var src = document.querySelectorAll('.bvn-quick a');
    if (!src.length) return true;
    var box = document.createElement('div');
    box.className = 'bvp-empty';
    Array.prototype.forEach.call(src, function (a) {
      var l = document.createElement('a');
      l.href = a.getAttribute('href');
      l.textContent = (a.textContent || '').trim();
      box.appendChild(l);
    });
    var wrap = btn.parentNode && btn.parentNode.parentNode;
    if (wrap) wrap.appendChild(box);
    return true;
  }
  function emptyWatch() {
    var n = 0;
    (function tick() {
      if (vangaEmpty() || ++n > 20) return;
      setTimeout(tick, 300);
    })();
  }
  function vangaWatch() {
    var n = 0;
    (function tick() {
      if (vanga() || ++n > 40) return;
      setTimeout(tick, 500);
    })();
  }

  /* ---------- Barre d'annonce : la croix se commande aussi au clavier ---------- */
  function promoKeys() {
    Array.prototype.forEach.call(document.querySelectorAll('.promo_banner-close'), function (c) {
      if (c.__bvpk) return;
      c.__bvpk = 1;
      c.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.click(); }
      });
    });
  }

  /* ---------- Sélecteur de langue / pays : envoi dès le choix ---------- */
  function loc() {
    Array.prototype.forEach.call(document.querySelectorAll('form.bvp-loc'), function (f) {
      if (f.__bvpl) return;
      f.__bvpl = 1;
      f.setAttribute('data-no-instant', '');
      Array.prototype.forEach.call(f.querySelectorAll('select'), function (s) {
        s.addEventListener('change', function () { try { f.submit(); } catch (e) {} });
      });
    });
  }

  function run() {
    vangaWatch();
    promoKeys();
    loc();
  }
  window.__bvpEmpty = emptyWatch;
  run();
  /* Le tiroir se (re)construit à l'ouverture : on surveille aussi les clics sur les icônes panier. */
  if (!window.__bvpGlobalL) {
    window.__bvpGlobalL = true;
    /* Filet : le tiroir (shadow DOM) est surveillé une fois par seconde (style + panier vide) ; coût négligeable. */
    setInterval(function () { if (!document.hidden && document.getElementById('vanga-smartcart')) { vanga(); vangaEmpty(); } }, 1000);
    window.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('a.mini_cart, .bv-bottomnav a[href*="cart"], [data-vanga-open], #vanga-smartcart')) { setTimeout(vangaWatch, 50); }
      setTimeout(emptyWatch, 500);
    }, true);
    if (window.MutationObserver) {
      new MutationObserver(function () { if (!document.getElementById('vanga-smartcart')) return; vanga(); }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (window.InstantClick && InstantClick.on) InstantClick.on('change', run);
})();
